import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { Rate } from '@mews-commander/data-access';
import { FilterFormValues } from '../../schemas';

interface ViewValueFieldProps {
    defaultRate?: Pick<Rate, 'id' | 'rateGroupId'>;
    rateOptions: SelectFieldProps['options'];
    rateGroupOptions: SelectFieldProps['options'];
}

export const ViewValueField = ({ defaultRate, rateOptions, rateGroupOptions }: ViewValueFieldProps) => {
    const { watch, setValue } = useFormContext<FilterFormValues>();
    const viewType = watch('view.type');

    useEffect(() => {
        if (!defaultRate) return;

        if (viewType === 'rate') {
            setValue('view.value', defaultRate.id);
            return;
        }

        setValue('view.value', defaultRate.rateGroupId);
    }, [defaultRate, viewType, setValue]);

    const selectProps =
        viewType === 'rate'
            ? {
                  label: lt('Rate'),
                  options: rateOptions,
              }
            : {
                  label: lt('RateGroup'),
                  options: rateGroupOptions,
              };

    return <SelectField {...selectProps} name="view.value" size="medium" showEmptyValue={false} required />;
};
